import { HOST } from "./config";
import axios from "axios";

async function fetchJSON(url, id, attr = {}) {
  try {
    const data = { ...attr };
    const response = await axios
      .post(`${HOST}/api/okno/${url}?id_avn_user=${id}`, data, { credentials: "include" })


    // const response = await fetch(HOST +'/api/okno/' + url, {
    //   method: "POST",
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //   },
    //   credentials: "include",
    //   body: JSON.stringify(data),
    // });

    if (!response.status) {
      const message = `Произошла ошибка ${response.statusText}`;
      new Error(message);
      return false;
    }

    const responseData = await response.data;
    if (responseData.status == 500) {
      //  throw new Error(responseData.err);
      window.location.replace("/");
    }
    return responseData;
  } catch (error) {
    new Error(error.message);
    return false;
  }
}

export default fetchJSON;
